import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert, Row, Col, Button } from '@themesberg/react-bootstrap';
import { get, post } from '../../services/back.service';
import DirectionPathButton from '../../components/widgets/directionPathButton';
import ModalMessage from '../../components/widgets/modalMessage';
import FilterOrders from '../../components/widgets/filterOrders';

function ListOrders({ canConvert = true }) {
  const location = useLocation();
  const basePath = location.pathname;
  const [msgGet, setMsgGet] = useState('');
  const [orders, setOrders] = useState([]);
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  const [showModalConvert, setShowModalConvert] = useState(false);
  const [orderToConvert, setOrderToConvert] = useState(null);
  const [, setLoadingConvert] = useState(false);
  const [currentFilter, setCurrentFilter] = useState({});

  const getOrders = useCallback(async (filter = {}) => {
    const params = {};
    if (filter.state?.length) params.state = filter.state.join(',');
    if (filter.placa) params.placa = filter.placa.toUpperCase();
    if (filter.applicant) params.applicant = filter.applicant;
    if (filter.init_date) params.init_date = filter.init_date;
    if (filter.end_date) params.end_date = filter.end_date;

    // const query = params.toString() ? `?${params.toString()}` : '';

    const responseOrders = await get(`/orders/`, {}, params);
    if (responseOrders.success) {
      const data = responseOrders.data?.orders || [];
      setOrders(data);
    } else {
      setMsgGet(responseOrders.message);
    }
  }, []);

  const searching = useCallback(async (data) => {
    setCurrentFilter(data);
    await getOrders(data);
  }, [getOrders]);

  useEffect(() => {
    getOrders({});
  }, [getOrders]);

  const editButton = (row) => {
    const isCreated = row.state === 'created';
    const cPath = basePath + '/order/' + row.id;
    return (
      <Row className="g-1">
        {isCreated && (
          <Col xs="auto">
            <DirectionPathButton path={cPath} variant="outline-primary" text="Editar" />
          </Col>
        )}
        {canConvert && isCreated && (
          <Col xs="auto">
            <Button variant="outline-success" size="sm" onClick={() => openModalConvert(row)}>
              Convertir
            </Button>
          </Col>
        )}
      </Row>
    );
  };

  const openModalConvert = (order) => {
    setOrderToConvert(order);
    setShowModalConvert(true);
  };

  const handleConvert = async () => {
    setLoadingConvert(true);
    const response = await post(`/orders/${orderToConvert.id}/convert/`, {});
    setLoadingConvert(false);

    if (response.success) {
      setAlert({ show: true, message: 'Orden convertida a peritaje exitosamente', type: 'success' });
      getOrders(currentFilter);
    } else {
      setAlert({ show: true, message: response.message || 'Error al convertir orden', type: 'danger' });
    }
    setShowModalConvert(false);
    setOrderToConvert(null);
  };

  return (
    <Base>
      {alert.show && (
        <Alert variant={alert.type} onClose={() => setAlert({ show: false })} dismissible>
          {alert.message}
        </Alert>
      )}

      <DirectionPathButton text="Crear Orden" path={basePath + '/order/0'} variant="primary" />

      <FilterOrders searching={searching} />

      <ListTables
        data={orders}
        editar={editButton}
        messageWd={msgGet}
      />

      <ModalMessage
        title="Confirmar Conversión"
        text={`¿Está seguro que desea convertir la orden #${orderToConvert?.id} (Placa: ${orderToConvert?.placa}) a peritaje?`}
        showProps={showModalConvert}
        funcAccept={handleConvert}
        funcClose={() => setShowModalConvert(false)}
      />
    </Base>
  );
}

export default ListOrders;